import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class LocalizationService {

  private language = new BehaviorSubject<string>('empty');

  // tslint:disable-next-line: max-line-length
  constructor(private translateService: TranslateService, private dateAdapter: DateAdapter<Date>, @Inject(PLATFORM_ID) private platformId) { }

  public initLanguage() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('language')) {
        //preload translation on app start
        this.translateService.getTranslation('fr');
        this.translateService.getTranslation('en');

        const lang = localStorage.getItem('language');


        this.translateService.use(lang);
        this.dateAdapter.setLocale(lang + '-CA');
        this.language.next(lang);
      } else {
        console.log(navigator.language);
        const lang = navigator.language || 'fr';
        if (lang.includes('fr')) {
          this.translateService.use('fr');
          this.dateAdapter.setLocale('fr-CA');
          this.language.next('fr');
        } else {
          this.translateService.use('en');
          this.dateAdapter.setLocale('en-CA');
          this.language.next('en');
        }
      }
    }
  }

  public changeLanguage(lang: string) {
    if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('language', lang);
        this.translateService.use(lang);
        this.dateAdapter.setLocale(lang + '-CA');
    }

    this.language.next(lang);
  }

  public getLanguageObs(): Observable<string> {
    return this.language.asObservable();
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/services/localization.service.ts